// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__1bULw","addWidgetButton":"Header_addWidgetButton__12b2N","dashboardTabs":"Header_dashboardTabs__13kA5","active":"Header_active__3xf5X"};